module.exports = __webpack_public_path__ + "static/media/ACAC-0031-Letter-of-Medical-Necessity-PDP-08-20.c5d3c4c9.docx";